import React, { useState } from 'react';

import { Container } from './styles';
import history from '~/services/history';

import Select, { components } from 'react-select';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { MdSearch, MdReply } from 'react-icons/md';

export default function Search() {
  const [keyWord, setKeyWord] = useState('');
  const [options, setOptions] = useState([]);
  const userType = useSelector(state => state.user.profile.tipoCliente);

  function handleGoBack() {
    if (history.length === 1) window.close();

    history.goBack();
  }

  function handleGoNavigate(screen, topic, topicId) {
    setKeyWord(screen);

    history.push({
      pathname: `${screen}`,
      state: {
        sTopic: topic,
        sTopicId: topicId,
      },
    });
  }

  useEffect(() => {
    if (userType[0] === 'Inquilino') {
      setOptions([
        { value: '/SegundaViaBoleto', label: '2º via boleto' },
        { value: '/FundoDeReserva', label: 'Fundo de reserva' },
        { value: '/SolicitarReparo', label: 'Solicitar um reparo' },
        {
          value: '/FAQ',
          label: 'Entrada no imóvel',
          topicId: 1,
          topic: 'Entrada no Imóvel',
        },
        {
          value: '/FAQ',
          label: 'Durante a locação',
          topicId: 2,
          topic: 'Durante a Locação',
        },
        {
          value: '/FAQ',
          label: 'Pagamentos e taxas',
          topicId: 3,
          topic: 'Pagamento e Taxas',
        },
        {
          value: '/FAQ',
          label: 'Saída do imóvel',
          topicId: 4,
          topic: 'Saída do Imóvel',
        },
        { value: '/Imovel', label: '+ Opções' },
      ]);
    }

    if (userType[0] === 'Proprietário') {
      setOptions([
        { value: '/Extrato', label: 'Extrato' },
        { value: '/Calendario', label: 'Calendário de repasse' },
        { value: '/MeusAnuncios', label: 'Meus Anúncios' },
        {
          value: '/FAQ',
          label: 'Entrada no imóvel',
          topicId: 1,
          topic: 'Entrada no Imóvel',
        },
        {
          value: '/FAQ',
          label: 'Durante a locação',
          topicId: 2,
          topic: 'Durante a Locação',
        },
        {
          value: '/FAQ',
          label: 'Pagamentos e taxas',
          topicId: 3,
          topic: 'Pagamento e Taxas',
        },
        {
          value: '/FAQ',
          label: 'Saída do imóvel',
          topicId: 4,
          topic: 'Saída do Imóvel',
        },
        { value: '/Imovel', label: '+ Opções' },
      ]);
    }
  }, [userType]);

  const CustomStyle = {
    option: (base, state) => ({
      ...base,
    }),
    container: base => ({
      ...base,
      '@media (min-width: 320px) and (max-width: 425px)': {
        width: '20rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '@media (max-width: 320px)': {
        width: '11rem',
      },
    }),
    control: (base, state) => ({
      ...base,
      width: '60rem',
      height: '50px',
      border: '2px solid var(--yellowDark)',
      borderRadius: '10px',
      margin: '10px 0 0 0',
      '&:hover': { borderColor: 'var(--yellowDark)' },
      boxShadow: state.isFocused ? 'var(--yellowDark)' : 0,

      '@media (max-width: 768px)': {
        width: '45rem',
      },
    }),
    valueContainer: base => ({
      ...base,
      height: '50px',
      padding: '0 15px',
    }),
    singleValue: base => ({
      ...base,
      height: '25px',
    }),
    indicatorsContainer: base => ({
      ...base,
      height: '46px',
      width: '3%'
    }),
    IndicatorContainer: base => ({
      ...base,
      padding: '0',
    }),
    indicatorSeparator: base => ({
      ...base,
      display: 'none'
    })
  };

  const CustomStyleOtherScreens = {
    option: (base, state) => ({
      ...base,
    }),
    container: base => ({
      ...base,
      '@media (min-width: 320px) and (max-width: 425px)': {
        width: '13rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '@media (max-width: 320px)': {
        width: '11rem',
      },
    }),
    control: (base, state) => ({
      ...base,
      width: '15rem',
      height: '50px',
      border: '2px solid var(--yellowDark)',
      borderRadius: '2px 2px 0 2px',
      margin: '20px 30px 0 0',
      '&:hover': { borderColor: 'var(--yellowDark)' },
      boxShadow: state.isFocused ? 'var(--yellowDark)' : 0,
    }),
    valueContainer: base => ({
      ...base,
      height: '50px',
      padding: '0 15px',
    }),
    singleValue: base => ({
      ...base,
      height: '25px',
    }),
    indicatorsContainer: base => ({
      ...base,
      height: '46px',
      width: '3%',
    }),
    IndicatorContainer: base => ({
      ...base,
      padding: '0',
    }),
    indicatorSeparator: base => ({
      ...base,
      display: 'none'
    })
  };

  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <MdSearch size={28} />
      </components.DropdownIndicator>
    );
  };

  return (
    <Container>
      {history.location.pathname === '/MeusImoveis' ? (
        <div>
          <Select
            name="search"
            label=""
            options={options}
            styles={CustomStyle}
            //components={{ DropdownIndicator }}
            components={{ DropdownIndicator:() => null }}
            onChange={v => handleGoNavigate(v.value, v.topic, v.topicId)}
            placeholder="Pesquisa rápida"
          />
        </div>
      ) : (
        <>
          <div>
            <button type="button" onClick={handleGoBack}>
              <MdReply size={24} className="return" />
              <span>Voltar</span>
            </button>
          </div>

          <div>
            <Select
              name="search"
              label=""
              options={options}
              styles={CustomStyleOtherScreens}
              //components={{ DropdownIndicator }}
              components={{ DropdownIndicator:() => null }}
              onChange={v => handleGoNavigate(v.value, v.topic, v.topicId)}
              placeholder="Pesquisa rápida"
            />
          </div>
        </>
      )}
    </Container>
  );
}
